export default new Set(['byAttributesOrigin', 'not_mapped_attribute_value_exception']);
